import { memo } from 'react';
import styled from '@emotion/styled';

import zIndices from '../../../../lib/zIndices';

import MobilePageTitle from './MobilePageTitle';
import MobileNavAndButton from './NavButton';

import type { ThemeProps } from '@emotion/react';
import type { NavProps } from '../Desktop/Nav';

const TitleBarWrap = styled('div')`
  height: 56px;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${zIndices.mobileNav};
  padding: 4px 8px;

  background-color: ${(props: ThemeProps): string =>
    props.theme.colors.background};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const MobileNavButtonSpacer = styled('div')`
  min-width: 40px;
`;

function MobileNav({
  pages,
  preferPageTitle,
}: NavProps & {
  preferPageTitle?: boolean | undefined;
}) {
  return (
    <TitleBarWrap>
      <MobileNavAndButton pages={pages} />
      <MobilePageTitle pages={pages} preferPageTitle={preferPageTitle} />
      <MobileNavButtonSpacer />
    </TitleBarWrap>
  );
}

export default memo(MobileNav);
